<template>
  <div :class="['FieldTextarea', { error: canShowError }]">
    <field-label v-if="label" :for-id="id">{{ label }}</field-label>
    <textarea
      :id="id"
      :name="name"
      :placeholder="placeholder"
      class="field"
      v-model="field.$model"
      :maxlength="maxlength"
    ></textarea>
    <field-error :show="canShowError">{{ errorMessage }}</field-error>
    <p v-if="availableChars && !!$scopedSlots.availableChars" class="counter">
      <slot name="availableChars" :chars="availableChars" />
    </p>
  </div>
</template>

<script>
import formField from "@mixins/form-field";
import FieldLabel from "@components/form/field-label";
import FieldError from "@components/form/field-error";

export default {
  name: "FieldTextarea",
  components: { FieldError, FieldLabel },
  mixins: [formField],
  props: {
    placeholder: { type: String, default: "" },
    maxlength: { type: Number, default: null }
  },
  computed: {
    availableChars() {
      if (this.maxlength) {
        return this.maxlength - this.field.$model.length;
      }
      return false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~$scss/_variables.scss";

.field {
  display: block;
  width: 100%;
  background: $color-white;
  border: 1px solid rgba($color-dark, 0.25);
  border-radius: 5px;
  font-size: 16px;
  line-height: normal;
  font-weight: $light;
  height: 90px;
  padding: 9px 16px;
  color: $color-dark;
  resize: none;
  overflow-y: auto;
  transition: border 0.4s ease-in-out;

  @media (min-width: $bootstrap-md) {
    font-size: 20px;
    height: 120px;
    padding: 9px 25px;
  }

  &::placeholder {
    color: rgba($color-grey, 0.75);
    opacity: 1;
  }

  .error & {
    border-color: $color-error;
  }
}

.counter {
  font-size: 16px;
  line-height: 1.25;
  color: rgba($color-dark, 0.5);
  padding: 1em 0 0;

  @media (min-width: $bootstrap-md) {
    font-size: 20px;
  }
}
</style>
